var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.checked)?_c('b-icon-check',{staticClass:"text-green h2"}):_c('b-icon',{staticClass:"text-red h2",attrs:{"icon":'x'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }